import React from 'react';
import '../styles/Banner.css';

const Banner = () => {
  return (
    <div className="banner">
      <h1 className="banner-title">Welcome to the Doctor Appointment System</h1>
      <p className="banner-subtitle">Book your appointments online and experience top-quality healthcare.</p>
    </div>
  );
};

export default Banner;
